<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J4hSpv/images/cover.jpg?1685327487073" alt="This image is the cover for the book Small Miracles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Miracles
      </h1>
      <p class="bookDescription body article font2">
        <p>When runaway Cal Harrison steps into a bar to escape the freezing rain, he meets Matt Kirkland, who buys him a meal and eventually takes him home for the night. But Cal's been on hard times, and he doesn't believe something as good as Matt could possibly happen to him. Not without setting him up for disaster. So Cal leaves—only to discover Matt’s not just a rich kid but a well-known millionaire. Soon Cal begins to question whether he should have swallowed his pride and left his difficult life behind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Holiday
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?387cd5bb